import type { IconData } from '@stacksjs/iconify-core'

export const travelSuitcase: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 4h4v12H0V4h4a4 4 0 1 1 8 0M6 4h4a2 2 0 1 0-4 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelSuitcase
